function revistaSearch() {
  'use strict';

  var RS = RevistaSearch;
  var CONFIG = RS.CONFIG;

  RS.state = {
    abortController: null,
    isLoading: false,
    lastCancelReason: null,
  };

  RS.dom = {
    form: document.querySelector(CONFIG.SELECTORS.form),
    queryInput: document.querySelector(CONFIG.SELECTORS.queryInput),
    matchRadios: Array.from(
      document.querySelectorAll(CONFIG.SELECTORS.matchRadios)
    ),
    sortSelect: document.querySelector(CONFIG.SELECTORS.sortSelect),
    dateFromInput: document.querySelector(CONFIG.SELECTORS.dateFromInput),
    dateToInput: document.querySelector(CONFIG.SELECTORS.dateToInput),
    typeCheckboxes: Array.from(
      document.querySelectorAll(CONFIG.SELECTORS.typeCheckboxes)
    ),
    resultsContainer: document.querySelector(CONFIG.SELECTORS.resultsContainer),
    resultsHeader: document.querySelector(CONFIG.SELECTORS.resultsHeader),
    resultsInfo: document.querySelector(CONFIG.SELECTORS.resultsInfo),
    resultsList: document.querySelector(CONFIG.SELECTORS.resultsList),
    paginationRoot: document.querySelector(CONFIG.SELECTORS.paginationRoot),
  };

  if (!RS.dom.form || !RS.dom.resultsContainer || !RS.dom.resultsList) {
    console.warn(
      '[revista-search] Elementos obrigatórios não encontrados. Sistema não inicializado.'
    );
    return;
  }

  RS.FormManager.setupDateRangeLimits(); // definido em ui.js
  RS.FormManager.setupTypeCheckboxes(); // definido em ui.js
  RS.dom.form.addEventListener('submit', function (e) {
    RS.SearchController.handleSubmit(e); // definido em api.js
  });

  /* global iniciarPaginacao */
  RS.state.paginationController = iniciarPaginacao({
    onPageChange: function (page) {
      if (!RS.state.currentParams) return;
      window.scrollTo({ top: 100, behavior: 'smooth' });
      var params = Object.assign({}, RS.state.currentParams, {
        page: page - 1,
      });
      RS.ParamsManager.updateUrl(params);
      RS.SearchController.performSearch(params);
    },
    onSizeChange: function (size) {
      if (!RS.state.currentParams) return;
      window.scrollTo({ top: 100, behavior: 'smooth' });
      var params = Object.assign({}, RS.state.currentParams, {
        page: 0,
        size: size,
      });
      RS.ParamsManager.updateUrl(params);
      RS.SearchController.performSearch(params);
    },
  });

  RS.SearchController.initializeFromUrl();
}
